<template>
  <div style="height:calc(100vh - 40px);overflow-y:auto;">
    <el-form :inline="true" :model="searchForm">
      <div class="row-bg">
        <el-row :gutter="24">
          <el-col :lg="5" :md="24">
            <el-form-item label="校区名称：">
              <el-input
                clearable
                v-model="searchForm.merchantName"
                placeholder="请输入"
                class="w100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :md="24">
            <el-form-item label="状态：">
              <el-select
                clearable
                v-model="searchForm.merchantStatus"
                placeholder="状态"
                class="w100"
              >
                <el-option
                  v-for="item in options"
                  :key="item.key"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <span>
            <el-button @click="resetForm">重置</el-button>
            <el-button type="primary" @click="getListHandler">查询</el-button>
          </span>
        </el-row>
      </div>
    </el-form>
    <!-- 表格 -->
    <el-card shadow="never" style="overflow-y: scroll; height: calc(100% - 80px);">
      <div slot="header" class="flex" style="align-items: center">
        <span>校区数据</span>
        <div class="flex_1"></div>
        <el-button type="primary" size="mini" @click="openAddModal"
        >添加
        </el-button>
        <text-button
          icon="el-icon-refresh"
          contentTit="刷新"
          @click.native="search"
        ></text-button>
        <text-button
          icon="el-icon-setting"
          contentTit="列设置"
          :colSetting="colSetting"
          @update="update"
          :ispopover="true"
          :baseColSetting="baseColSetting"
        ></text-button>
      </div>

      <el-table
        :default-sort="{ prop: 'open_date', order: 'descending' }"
        :key="tableKey"
        fit
        :highlight-current-row="true"
        :data="tableData"
      >
        <el-table-column
          v-for="item of defaultHeader"
          :key="item.label"
          :label="item.label"
          :align="item.align ? item.align : 'left'"
          :min-width="item.width ? item.width : 'auto'"
          :sortable="item.sortable ? item.sortable : false"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <template v-if="item.label === '状态'">
              <span
                class="span-state"
                :style=" 'backgroundColor' +':' +getAccountColor(scope.row.status)"
              ></span>
              <span  :style=" 'color' +':' + getAccountColor(scope.row.status)">{{ scope.row.status }}</span>
            </template>
            <template v-else-if="item.label === '创建时间'">
              <span v-if="scope.row.createTime"> {{ scope.row.createTime.substring(0, 19) }}</span>
              <span v-else>--</span>
            </template>
            <template v-else-if="item.label === '操作'">
              <!--              <el-button-->
              <!--                style="margin-left: 8px"-->
              <!--                type="text"-->
              <!--                ref="openDetail"-->
              <!--                @click="openDetailModal(scope.row)"-->
              <!--              >查看教师</el-button-->
              <!--              >-->
              <!--              <el-button-->
              <!--                style="margin-left: 8px"-->
              <!--                type="text"-->
              <!--                ref="openDetailadMinistrators"-->
              <!--                @click="openDetailadMinistrators(scope.row)"-->
              <!--              >查看管理员</el-button-->
              <!--              >-->
              <el-button
                style="margin-left: 8px"
                type="text"
                @click="openDetail(scope.row)"
              >管理
              </el-button>
              <el-popconfirm
                style="margin-left: 10px;"
                @onConfirm="confirmStatus(scope.row)"
                @confirm="confirmStatus(scope.row)"
                :title="`确定要将该数据改为‘${
                                  statusOptions[scope.row.status]
                                }’状态吗？`"
              >
                <el-button type="text" slot="reference">
                  {{ statusOptions[scope.row.status] }}
                </el-button>
              </el-popconfirm>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :size="size"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.pageNum"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="pageInfo.pageSize"
        :total="pageInfo.total"
        layout="total, sizes, prev, pager, next, jumper"
        background
      >
      </el-pagination>
    </el-card>

    <AddModal
      ref="add"
      title="添加校区"
      type="primary"
      @submit="addMember"
    ></AddModal>
    <EditModal ref="edit" title="编辑校区" :item="item" @submit="editMember"/>
    <!-- <DetailModal ref="detail" title="查看" /> -->
  </div>
</template>
<script>
import getAccountColor from "@/mixins/getStateColor";
import {
  getMerchantList,
  $addMerchant,
  $editMerchant,
  forbiddenMerchant
} from "@/api/member/merchant";
import AddModal from "@/views/member/AddModalSchool";
import EditModal from "@/views/member/EditModalSchool";
import DetailModal from "@/views/member/DetailModal";
import TextButton from "@/components/TextButton";
// 默认展示列

const baseColSetting = [
  {
    label: "校区名称",
    prop: "merchantName",
    state: true,
    align: "left",
  },
  {
    label: "状态",
    prop: "state",
    state: true,
    align: "center",
    width: "150",
  },
  {
    label: "创建时间",
    prop: "createTime",
    state: true,
    sortable: true,
    align: "center",
    width: "150",
  },
  {
    label: "操作",
    state: true,
    align: "center",
    width: "150",
  },
];
export default {
  mixins: [getAccountColor],
  components: {AddModal, EditModal, DetailModal, TextButton},
  data() {
    return {
      tableKey: 1,
      item: {},
      title: "",
      size: "small",
      tableData: [],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        needCount: true,
      },
      searchForm: {
        loginName: null,
        name: null,
        telNumber: null,
        merchantStatus: null,
        merchantName: null,
      },
      // statusOptions: {
      //   1: "正常",
      //   // "2":"删除",
      //   3: "禁用",
      // },
      statusOptions: {
        "正常": "禁用",
        // "2":"删除",
        "禁用": "启用",
      },
      options: [
        {
          value: "正常",
          label: "正常",
        },
        // {
        //   value: '2',
        //   label: '删除',
        // },
        {
          value: "禁用",
          label: "禁用",
        },
      ],
      colSetting: JSON.parse(JSON.stringify(baseColSetting)), // 表格展示列
      baseColSetting: JSON.parse(JSON.stringify(baseColSetting)),
    };
  },
  created() {
    this.getListHandler();
  },
  computed: {
    defaultHeader() {
      return this.colSetting.filter((item) => item.state);
    },
  },
  methods: {
    /**
     * 获取列表
     */

    async getListHandler() {
      let responseData = await getMerchantList(
        {
          pageNum: this.pageInfo.pageNum,
          pageSize: this.pageInfo.pageSize,
          needCount: this.pageInfo.needCount,
          ...this.searchForm,
        }
      );
      console.log(responseData)
      if (responseData && responseData.state == "success") {
        this.tableData = responseData.body.list;
        this.pageInfo.total = responseData.body.total;
      }
    },
    /**
     * 获取详情
     */
    async getDetail(id) {
      return this.tableData.filter((item) => item.id == id)[0];
    },
    confirmStatus(item) {
      const {id, state} = item;
      forbiddenMerchant({
        id,
        merchantStatus: state == "正常" ? "禁用" : '正常',
      }).then(() => {
        this.getListHandler();
      });
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.pageInfo.pageNum = 1;
      this.pageInfo.pageSize = 10;
      this.searchForm = {
        loginName: null,
        name: null,
        telNumber: null,
        merchantStatus: null,
        merchantName: null,
      };
      this.getListHandler();
    },
    /**
     * 查看
     */
    handleClick(item) {
    },
    /**
     * 页码改变
     */
    handleCurrentChange(page) {
      this.pageInfo.pageNum = page;
      this.getListHandler();
    },
    /**
     * 刷新
     */
    search() {
      this.pageInfo.pageNum = 1;
      this.getListHandler();
    },
    update(data) {
      this.tableKey = this.tableKey + 1;
      if (data.lenght !== 0) {
        this.colSetting.forEach((item) => {
          item.state = false;
          data.forEach((ele) => {
            if (ele === item.label && !item.state) {
              item.state = true;
            }
          });
        });
      } else {
        this.colSetting = [];
      }
    },
    openDetail(row) {
      // 打开校区详情
      this.$router.push({
        path: '/merchantAccount/merchantAccountDetail',
        query: {
          id: row.id,
          title: row.merchantName,
        },
      })
    },
    /**
     * 打开编辑弹窗
     */
    openEditModal(item) {
      // TODO 添加获取详情
      this.item = item || {};
      this.$nextTick(() => {
        this.$refs.edit.dialogVisible = true;
      });
    },
    /**
     * 打开添加弹窗
     */
    openAddModal() {
      this.$refs.add.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.add.initData(); //清空表单
      });
    },
    /**
     * 打开详情老师、管理员
     */

    openDetailModal(item) {
      this.$router.push({path: '/merchantAccount/teacher', query: {merchantId: item.id}})
    },
    openDetailadMinistrators(item) {
      this.$router.push({path: '/merchantAccount/ministrators', query: {merchantId: item.id}})
    },
    /**
     * pageSize改变
     */
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.getListHandler();
    },
    /**
     * 添加成员
     */
    async addMember(value) {
      const {merchantName, merchantStatus} = value;
      const response = await $addMerchant({merchantName, merchantStatus,});
      if (response.state == "success") {
        this.$message.success("添加成功");
        this.getListHandler();
        this.$refs.add.dialogVisible = false;
      } else {
        this.$message.warning("添加失败");
      }
    },
    async editMember(value) {
      // console.log(value,'wangjing11')
      // console.log(JSON.parse(JSON.stringify(value)),'wangjing11')

      const {id, merchantName, status} = value;
      // const response = await $editMerchant(JSON.parse(JSON.stringify(value)));
      const response = await $editMerchant({id, merchantName, status});

      if (response.state == "success") {
        this.$message.success("编辑成功");
        this.getListHandler();
        this.$refs.edit.dialogVisible = false;
      } else {
        this.$message.warning("编辑失败");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.outer-style {
  height: calc(100% - 50px);
  overflow: auto;
}

@import "../../style/container.scss";

/deep/ .el-form--inline .el-form-item {
  margin-right: 0;
}
</style>

